module.exports = __webpack_public_path__ + "8d51d87f3c41a59b60cd74d68763aca4.svg";